import { CreateDrawerFormProps, FormDrawer } from "@dgs/core";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterFormDrawerContent } from "./FilterFormDrawerContent";
import { FilterItem, FilterOptionResource, OnDemandFilterFormValues } from "./filterTypes";
import { emptyAdvancedFilter } from "./utils";

interface Props extends CreateDrawerFormProps<OnDemandFilterFormValues> {
	filter: FilterOptionResource | null;
}

export const FilterDrawer: FC<Props> = ({ filter, ...drawerProps }) => {
	const { t } = useTranslation();
	const initialValues = useMemo(() => (filter ? filter : emptyAdvancedFilter), [filter]);

	const validate = useCallback(
		(filter: OnDemandFilterFormValues) => {
			const errors: { [K in keyof OnDemandFilterFormValues]?: any } = {};
			filter.filterItems.forEach((item, index) => {
				const error: { [K in keyof FilterItem]?: any } = {};

				if (!item.operator) {
					error.operator = t("Field is required");
				}

				if (item.value == null) {
					error.value = t("Field is required");
				}

				if (item.operator === "BETWEEN" && item.value && item.value.start > item.value.end) {
					error.value = { start: t("Start must before end"), end: t("Start must before end") };
				}

				if (Object.keys(error).length) {
					errors.filterItems = { ...errors.filterItems, [index]: error };
				}
			});

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...drawerProps}
			title={t("Filter")}
			validate={validate}
			initialValues={initialValues}
			onClose={() => drawerProps.onClose?.()}
			renderForm={(props) => <FilterFormDrawerContent {...props} />}
		/>
	);
};
